import {
  GET_COMPLAINTS_LIST,
  GET_COMPLAINTS_LIST_FAILURE,
  GET_COMPLAINTS_LIST_SUCCESS,
} from '../../modules/constants';

// get complaints list
export const getComplaintsListRequest = (state, action) => {
  return {
    ...state,
    isLoading: true,
  };
};
export const getComplaintsListRequestSuccess = (state, action) => {
  const { payload: data } = action;
  if (data.status === 200) {
    return {
      ...state,
      isLoading: false,
      complaintsList: data.data,
    };
  }
  return {
    ...state,
    isLoading: false,
    complaintsList: [],
  };
};
export const getComplaintsListRequestFailure = (state, action) => {
  return {
    ...state,
    isLoading: false,
    complaintsList: [],
  };
};

// Action Handlers
const ACTION_HANDLERS = {
  [GET_COMPLAINTS_LIST]: getComplaintsListRequest,
  [GET_COMPLAINTS_LIST_SUCCESS]: getComplaintsListRequestSuccess,
  [GET_COMPLAINTS_LIST_FAILURE]: getComplaintsListRequestFailure,
};

// default initial state
const initialState = {
  isLoading: false,
  complaintsList: [],
};

export default function complaintsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
